<template>
  <div>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4>
        <v-card>

          <div v-show="busy" class="text-xs-center" style="position:absolute; z-index:2; background-color:rgba(255,255,255,.95); width:100%; height:100%;">
            <v-layout align-center justify-center row fill-height>
              <v-flex>
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <div>
                <h1 class="headline mt-4 mt-4" style="text-align:center;">Loading, please wait...</h1>
                </div>
              </v-flex>
            </v-layout>
          </div>

          <div v-show="error" class="text-xs-center" style="position:absolute; z-index:2; background-color:rgba(255,255,255,1); width:100%; height:100%;">
            <v-layout align-center justify-center row fill-height>
              <v-flex>
                <div class="px-3">
                  <v-alert :value="true" color="error" icon="warning">{{ error }}</v-alert>
                </div>
              </v-flex>
            </v-layout>
          </div>

          <h1 class="headline pt-4 pb-4" style="text-align:center;">Pay invoice</h1>
          <h3 class="title pt-1 pb-1" style="text-align:center;">{{ invoice.trip_name }}</h3>
          <v-card-text>
            <v-container fluid >
              <v-layout align-center column>
                <v-flex>
                  <div style="min-width: 250px; margin-bottom:20px;">
                    <div>Invoice no: {{ invoice.fortnox_invoice_no }} </div>
                    <div>Booking no: {{ invoice.booking_id }} </div>
                    <div v-if="invoice.paid_amount>0">
                      <div>Total amount: {{ invoice.amount_total }} {{ invoice.currency }}</div>
                      <div style="font-weight:bold;">Remaining balance: {{ (invoice.amount_total-invoice.paid_amount).toFixed(2) }} {{ invoice.currency }}</div>
                    </div>
                    <div v-else  style="font-weight:bold;">Total amount: {{ invoice.amount_total }} {{ invoice.currency }}</div>
                  </div>
                  <div v-if="invoice.paid_amount>0">
                    <v-btn color="primary" class="mr-0 ml-0" style="width:100%" @click="start_payment(0)">Pay remaining amount</v-btn>
                  </div>
                  <div v-else-if="invoice.deposit_allowed>0">
                    <v-btn color="primary" class="mr-0 ml-0" style="width:100%" @click="start_payment(0)">Pay full amount</v-btn>
                    <v-btn color="primary" class="mr-0 ml-0" style="width:100%" @click="start_payment(1)">Pay deposit (20%)</v-btn>
                  </div>
                  <div v-else>
                    <v-btn color="primary" class="mr-0 ml-0" style="width:100%" @click="start_payment(0)">Pay</v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Login from '~/pages/auth/login'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'payment-view',
  components: {
    'login-view': Login
  },
  data: () => ({
    busy: false,
    error: '',
    token: '',
    invoice: {},
  }),

  computed: mapGetters({
    authenticated: 'authCheck'
  }),

  mounted() {
    this.busy = true
    this.token = this.$route.params.token

    axios.get(process.env.API_URL+'/invoice/' + this.token)
    .then((response) => {
      this.invoice = response.data;
      this.busy = false
    })
    .catch((error) => {
      this.error = "Something went wrong, try again later..."
      this.busy = false
    })
  },

  watch: {
    loginform : {
      handler: function (val, oldVal) {
        this.clearerror()
      },
      deep: true
    }
  },

  methods: {
    start_payment(payment_type){
      var vm = this;
      Vue.set(this, 'busy', true);

      axios.post(process.env.API_URL+'/invoice_start_payment/' + this.token, {
        payment_type: payment_type
      })
      .then((response) => {
        if(response.data.success && response.data.stripe.id){

          var stripe = Stripe(process.env.STRIPE_KEY);

          stripe.redirectToCheckout({
            // Make the id field from the Checkout Session creation API response
            // available to this file, so you can provide it as parameter here
            // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
            sessionId: response.data.stripe.id
          }).then(function (result) {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer
            // using `result.error.message`.
            Vue.set(vm, 'error', result.error.message);
            Vue.set(vm, 'busy', false);
          });
        } else {
          Vue.set(this, 'error', "Something went wrong, try again later...");
          Vue.set(this, 'busy', false);
        }
      })
      .catch((error) => {
        Vue.set(this, 'error', "Something went wrong, try again later...");
        Vue.set(this, 'busy', false);
      })
    },
  },

  metaInfo () {
    return { title: this.$t('home') }
  }
}
</script>



// WEBPACK FOOTER //
// pay.vue?7e53278a